import apiClient from './apiConfig';

export const getSettings = async () => {
  try {
    const response = await apiClient.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export const updateSettings = async (settings: any) => {
  try {
    const response = await apiClient.put('/settings', { settings });
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};

export const uploadMenuPdf = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('menu_pdf', file);

  const response = await apiClient.post('/settings/menu-pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data.url;
};
